
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, Calendar } from 'lucide-react';
import FadeIn from '../components/FadeIn';
import SEO from '../components/SEO';
import confetti from 'canvas-confetti';

const ThankYou = () => {
    useEffect(() => {
        // Trigger confetti on mount
        const duration = 3000;
        const end = Date.now() + duration;

        const frame = () => {
            confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ['#A2CB52', '#20222D', '#ffffff']
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ['#A2CB52', '#20222D', '#ffffff']
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        };

        frame();
    }, []);

    return (
        <div className="bg-white min-h-screen flex flex-col">
            <SEO
                title="Thank You | BPO Consultants"
                description="Thank you for contacting BPO Consultants. We will get back to you shortly."
                noIndex={true} // Don't index thank you pages
            />

            <div className="flex-grow flex items-center justify-center relative overflow-hidden bg-[#20222D] pt-32 pb-20 px-4">
                {/* Background Elements */}
                <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10">
                    <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#A2CB52] rounded-full blur-[100px]"></div>
                    <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#4F46E5] rounded-full blur-[100px]"></div>
                </div>

                <div className="max-w-xl w-full relative z-10 text-center">
                    <FadeIn>
                        <div className="mb-8 inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#A2CB52]/20 text-[#A2CB52] backdrop-blur-sm border border-[#A2CB52]/40">
                            <CheckCircle size={48} strokeWidth={2.5} />
                        </div>

                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                            Message Received!
                        </h1>

                        <p className="text-xl text-gray-300 mb-10 leading-relaxed">
                            Thanks for reaching out. A member of our team will review your inquiry and get back to you within 24 hours.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Link
                                to="/"
                                className="inline-flex items-center justify-center bg-white text-[#20222D] px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105"
                            >
                                <Home size={20} className="mr-2" />
                                Return Home
                            </Link>

                            <Link
                                to="/contact"
                                className="inline-flex items-center justify-center bg-[#A2CB52] text-[#20222D] px-8 py-4 rounded-xl font-bold text-lg hover:bg-[#B5D575] transition-all transform hover:scale-105"
                            >
                                <Calendar size={20} className="mr-2" />
                                Book a Call
                            </Link>
                        </div>
                    </FadeIn>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
